<div id="slider">
  <div id="templatemo_wrapper">

    <div id="header">

      <h1><a href="http://www.templatemo.com/page/1">Wodden Wall<span>Free CSS Template</span></a></h1>
    </div>

    <div id="menu">
      <ul class="navigation">
        <li><a href="#home" class="selected">Home<span class="ui_icon home"></span></a></li>
        <li><a href="#aboutus">About Us<span class="ui_icon aboutus"></span></a></li>
        <li><a href="#services">Services<span class="ui_icon services"></span></a></li>
        <li><a href="#gallery">Gallery<span class="ui_icon gallery"></span></a></li>
        <li><a href="#contactus">Contact Us<span class="ui_icon contactus"></span></a></li>
      </ul>
    </div>

    <div id="content">

      <div class="scroll">
        <div class="scrollContainer">

          <div class="panel" id="home">
            <div class="col_320 float_l">
              <h2>Introduction</h2>

              <a href="http://www.templatemo.com/page/1"><img src="assets/images/templatemo_image_01.jpg" alt="image"
                  class="image_wrapper" /></a>
              <p><em>Nullam at erat ipsum, quis tincidunt mauris. Nunc sit amet sapien eget eros iaculis hendrerit quis
                  a enim.</em></p>
              <p>Wooden Wall is one of the <a href="http://www.templatemo.com" target="_parent">Free CSS Template</a>
                from <a href="http://www.templatemo.com">templatemo.com</a> website. Feel free to edit and apply this
                layout for your websites. Validate <a href="http://validator.w3.org/check?uri=referer"
                  rel="nofollow"><strong>XHTML</strong></a> &amp; <a
                  href="http://jigsaw.w3.org/css-validator/check/referer" rel="nofollow"><strong>CSS</strong></a>.
                Credit goes to <a href="http://www.icojoy.com" target="_blank">Onebit icons</a> for icons used in this
                template. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam sapien leo, luctus non molestie
                eu, bibendum in dolor.</p>
            </div>

            <div class="col_320 float_r">
              <h2>New Approaches</h2>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse in lectus turpis. Aliquam lacus
                turpis, dapibus eget, tincidunt eu, lobortis et, magna. Integer pellentesque dignissim diam. Quisque
                ornare pulvinar lorem. </p>
              <ul class="service_list">
                <li><a href="#" class="service_one">Sed nec eros egestas nisl</a></li>
                <li><a href="#" class="service_two">Morbi sed nulla ac est cursus</a></li>
                <li><a href="#" class="service_three">Curabitur ullamcorper nibh</a></li>
                <li><a href="#" class="service_four">Pellentesque adipiscing</a></li>
                <li><a href="#" class="service_five">Vestibulum urna purus</a></li>
              </ul>
            </div>
          </div> <!-- end of home -->

          <div class="panel" id="aboutus">
            <h1>About Us</h1>
            <div class="image_wrapper image_fl"><img src="assets/images/templatemo_image_02.jpg" alt="image" /></div>
            <p><em>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse in lectus turpis. Vivamus cursus
                tortor quis leo ullamcorper auctor quis tincidunt metus.</em></p>
            <p align="justify">Vestibulum vitae lectus a leo commodo egestas. Sed et ligula mauris. Donec interdum
              iaculis eros, sed porttitor justo ornare ac. Suspendisse ultrices arcu auctor sapien malesuada dictum. <a
                href="#">Vivamus non</a> ante sit amet ligula dignissim blandit ut sit amet purus. Sed tristique euismod
              lectus sed scelerisque. Curabitur convallis fringilla ante, eget eleifend magna iaculis eget. Praesent at
              nunc tellus. Sed sed auctor odio. Maecenas ut mauris eu ligula placerat tempor vel ac augue. Integer
              fermentum, ante eget sodales lacinia, nisl diam semper elit, non hendrerit nunc urna vitae erat. Etiam vel
              nisi risus.</p>
            <p align="justify">Duis nulla diam, posuere ac, varius id, ullamcorper sit amet, libero. Nam sodales, pede
              vel dapibus lobortis, ipsum diam molestie risus, a vulputate risus nisl pulvinar lacus. Vestibulum tempus
              porttitor ipsum, ut dictum metus molestie eu. <a href="#">Donec interdum</a>, mi ut facilisis posuere,
              neque sapien lacinia urna, nec hendrerit dolor arcu sed justo. Aenean rhoncus porttitor dolor non posuere.
              Nulla eu mi id tellus vehicula pellentesque et vitae magna. </p>

          </div>

          <div class="panel" id="services">
            <div class="col_320 float_l">
              <h1>Overview</h1>
              <p><em>Nam at arcu libero, ut venenatis elit. Nulla eget risus turpis, non aliquet dui ultricies elementum
                  convallis non. </em></p>
              <p align="justify">Sed eu libero quis neque laoreet cursus. Fusce elit metus, elementum nec consequat a,
                interdum vitae est. Aliquam sit amet odio vitae dui blandit elementum. Ut eu dolor nunc. Nam in nunc sed
                mi adipiscing lacinia suscipit eget tortor.</p>
              <p align="justify">Praesent at erat a magna ultricies bibendum. Sed sagittis mollis nulla non interdum.
                Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Lorem ipsum dolor
                sit amet, consectetur adipiscing elit. Nunc mauris risus, ornare eget iaculis quis, sagittis et mi.
                Aenean in leo est. Etiam dictum, arcu nec feugiat tincidunt, tellus dolor consequat magna, at fringilla
                enim turpis vel massa.</p>

            </div>
            <div class="col_320 float_r">
              <h1>Web Services</h1>
              <p>Aliquam lacus turpis, dapibus eget, tincidunt eu, lobortis et, magna. Integer pellentesque dignissim
                diam. Quisque ornare pulvinar lorem.</p>

              <ul class="service_list">
                <li><a href="#" class="service_one">Sed nec eros egestas nisl</a></li>
                <li><a href="#" class="service_two">Morbi sed nulla ac est cursus</a></li>
                <li><a href="#" class="service_three">Curabitur ullamcorper nibh</a></li>
                <li><a href="#" class="service_four">Pellentesque adipiscing</a></li>
                <li><a href="#" class="service_five">Vestibulum urna purus</a></li>
              </ul>
            </div>
          </div>

          <div class="panel" id="gallery">
            <h1>Web Templates Gallery</h1>

            <div id="gallery_container">
              <div class="gallery_box">
                <img src="assets/images/gallery/image_01.jpg" alt="01" />
                <h4>Project Title 1</h4>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean nec ligula vitae ipsum blandit
                  condimentum. Nam fringilla luctus mauris, non ornare turpis lobortin.</p>
                <div class="btn_more"><a href="#">Visit <span>&raquo;</span></a></div>
                <div class="cleaner"></div>
              </div>
              <div class="gallery_box">
                <img src="assets/images/gallery/image_02.jpg" alt="02" />
                <h4>Project Title 2</h4>
                <p>Donec ac eros ac nunc blandit hendrerit. Vestibulum tincidunt, odio at ultricies sollicitudin, ante
                  felis luctus justo, non venenatis quam mauris non tortor.</p>
                <div class="btn_more"><a href="#">Visit <span>&raquo;</span></a></div>
                <div class="cleaner"></div>
              </div>
              <div class="gallery_box">
                <img src="assets/images/gallery/image_03.jpg" alt="03" />
                <h4>Project Title 3</h4>
                <p> Mauris ligula tortor, congue laoreet rutrum eget, suscipit nec augue. In congue consectetur est, sit
                  amet hendrerit velit adipiscing eget.</p>
                <div class="btn_more"><a href="#">Visit <span>&raquo;</span></a></div>
                <div class="cleaner"></div>
              </div>
              <div class="gallery_box">
                <img src="assets/images/gallery/image_04.jpg" alt="04" />
                <h4>Project Title 4</h4>
                <p> Curabitur iaculis, erat pharetra porttitor sollicitudin, turpis lectus placerat arcu, ac mattis eros
                  sem ut metus. Nunc congue iaculis lectus in interdum.</p>
                <div class="btn_more"><a href="#">Visit <span>&raquo;</span></a></div>
                <div class="cleaner"></div>
              </div>
              <div class="gallery_box">
                <img src="assets/images/gallery/image_05.jpg" alt="05" />
                <h4>Project Title 5</h4>
                <p> Curabitur iaculis enim dolor. Sed quis augue ligula. Quisque aliquet egestas felis, in egestas
                  turpis sodales et. In ac diam ut orci viverra bibendum. </p>
                <div class="btn_more"><a href="#">Visit <span>&raquo;</span></a></div>
                <div class="cleaner"></div>
              </div>
              <div class="gallery_box">
                <img src="assets/images/gallery/image_06.jpg" alt="06" />
                <h4>Project Title 6</h4>
                <p>Sed in viverra nulla. Duis rutrum vehicula ligula, non tempor nunc congue et. Nunc sit amet tortor
                  nulla, ut eleifend enim sed condimentum tellus vestibulum in.</p>
                <div class="btn_more"><a href="#">Visit <span>&raquo;</span></a></div>
                <div class="cleaner"></div>
              </div>
              <div class="cleaner"></div>
            </div>

          </div>

          <div class="panel" id="contactus">
            <h1>Contact Us Now!</h1>

            <div class="col_320 float_l">
              <div id="contact_form">

                <form method="post" name="contact" action="#contactus">

                  <label for="author">Name:</label> <input name="author" type="text" class="input_field" id="author"
                    maxlength="60" />
                  <div class="cleaner_h10"></div>

                  <label for="email">Email:</label> <input name="email" type="text" class="input_field" id="email"
                    maxlength="60" />
                  <div class="cleaner_h10"></div>

                  <label for="text">Message:</label> <textarea id="text" name="text" rows="0" cols="0"
                    class="required"></textarea>
                  <div class="cleaner_h10"></div>

                  <input type="submit" class="submit_btn float_l" name="submit" id="submit" value="Send" />
                  <input type="reset" class="submit_btn float_r" name="reset" id="reset" value="Reset" />

                </form>

              </div>
            </div>

            <div class="col_320 float_r">

              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Suspendisse in lectus turpis. Vivamus cursus tortor quis leo ullamcorper auctor quis tincidunt metus.
              </p>

              <h4>Our Address</h4>

              <h6>Web Design Company</h6>
              110-160 Vitae urna blandit est egestas, <br />
              Pulvinar sit amet convallis eget, 20180<br />
              Lorem ipsum dolor<br />

              <br />
              Tel: 020-010-7800<br />
              Fax: 020-010-6800
            </div>
          </div>

        </div>
      </div>

      <!-- end of scroll -->

    </div> <!-- end of content -->

    <div id="footer">

      Copyright © 2048 <a href="#">Your Company Name</a> -
      <a href="http://www.iwebsitetemplate.com" target="_parent">Website Templates</a>
      by <a href="http://www.templatemo.com" target="_parent">Free CSS Templates</a>

    </div>

  </div> <!-- end of wrapper -->
</div> <!-- end of slider -->
